import { render, staticRenderFns } from "./tagSelection.vue?vue&type=template&id=64515f4a&scoped=true&"
import script from "./tagSelection.vue?vue&type=script&lang=js&"
export * from "./tagSelection.vue?vue&type=script&lang=js&"
import style0 from "./tagSelection.vue?vue&type=style&index=0&id=64515f4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64515f4a",
  null
  
)

export default component.exports